
import { APIRequest, APIRequestDtoImpl } from '../apiRequest';


export interface SettingsRequest extends APIRequest
{
   
}

export class SettingsRequestImpl extends APIRequestDtoImpl implements SettingsRequest
{
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/settings/settingsrequest.tsx